export function request(id, index, hotRefresh) {
    return {
        type: 'FRAUD_AND_COMPLIANCE_QUERY_REQUEST',
        id,
        index,
        hotRefresh
    };
}

export function error(id, errors) {
    return {
        type: 'FRAUD_AND_COMPLIANCE_QUERY_ERROR',
        errors,
        id
    };
}

export function finish(id, data, index) {
    return {
        type: 'FRAUD_AND_COMPLIANCE_QUERY_FINISH',
        index,
        data,
        id
    };
}

export function clear(id) {
    return {
        type: 'FRAUD_AND_COMPLIANCE_QUERY_CLEAR',
        id
    };
}
